import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./_Styles/ScrollToTop.css";

export const ScrollToTopButton = ({ offset = 400 }) => {

    const [useIsVisible, setIsVisible] = useState(false);

    useEffect(() => {

        const onScroll = () => setIsVisible(window.scrollY > offset);

        onScroll();

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);

    }, [offset]);

    if (!useIsVisible) return null;

    return (
        <button type="button" className="LStudio__app_scroll_top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Volver arriba" title="Volver arriba">
            <FaArrowUp />
        </button>
    );
};
